import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconArrowRight, IconChat } from '@redteclab/icons'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../global-config'
import { urlResolverGetDirectContactPage } from '../../url-handling'

export const OtherTopicsContactFormPageCta: FC = () => {
  const globalConfig = useGlobalConfigContext()

  return (
    <Button<'a'>
      className="w-full gap-1 rounded-m bg-light-brand-medium px-4 py-6"
      data-qa-id="help-center-contact-page-write-us"
      endIcon={<IconArrowRight className="fill-dark-brand" />}
      href={urlResolverGetDirectContactPage(globalConfig)}
      id="contact.email"
      size="large"
      slots={{ root: 'a' }}
      startIcon={<IconChat className="fill-dark-brand" />}
      variant="text"
    >
      <span className="grow whitespace-normal text-start">
        <FormattedMessage id="help.centre.others.options.write.us" />
      </span>
    </Button>
  )
}
